export const enum VolleyballResultId {
  FirstSet = 43,
  SecondSet = 44,
  ThirdSet = 45,
  FourthSet = 46,
  FifthSet = 47,
  GoldenSet = 410,
}
